import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/css/global.css'

import axios from 'axios'

Vue.prototype.$http = axios

// axios.defaults.baseURL = 'http://localhost:9090/server-api/'
// axios.defaults.baseURL = 'http://192.168.31.113:9090/api/'
axios.defaults.baseURL = 'http://sheyingxiehui.qianjiawang.vip/api/'
// axios.defaults.baseURL = 'https://lueyangyibao.sxjzsy.com/server-api/'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
